module.exports = __webpack_public_path__ + "assets/ic-coinidol.fde0951c.svg";